import { GivelifyButton, GivelifyLabel } from '@givelify/ui';
import { Grid } from '@mui/material';
import { SuggestionWrapper } from './style';
import { OrganizationSuggestionsResponse } from 'store/signup/types';
import { pushEvent } from 'utils/clevertapUtils';
import { CLICK_EVENT, RESULTS_MODAL } from 'utils/clevertapEvents';
import { useSelector } from 'react-redux';
import { AppState } from 'store';
import { Features } from 'store/featureFlags/types';
import { SEARCH_EXPERIMENT, SEARCH_UI_EXPERIMENT } from 'utils/clevertapVariantFlags';

type SuggestionItemProps = {
    item: OrganizationSuggestionsResponse;
    onSelect: (data: OrganizationSuggestionsResponse) => void;
};

export const SuggestionItem: React.FC<SuggestionItemProps> = ({
    item,
    onSelect,
}) => {
    const { newSearchUIEnabled, v2SearchAPIEnabled } =
        useSelector((state: AppState) => ({
            newSearchUIEnabled: state.FeatureFlagging.features[Features.SEARCH_UI_V2],
            v2SearchAPIEnabled: state.FeatureFlagging.features[Features.SEARCH_API_V2],
        }));

    const handleSelect = () => {
        pushEvent(CLICK_EVENT, {
            name: "Select",
            location: RESULTS_MODAL,
            [SEARCH_EXPERIMENT]: v2SearchAPIEnabled ? 'on' : 'off',
            [SEARCH_UI_EXPERIMENT]: newSearchUIEnabled ? 'on' : 'off'
        });
        onSelect(item);
    };

    return (
        <SuggestionWrapper
            container
            alignItems="center"
            justifyContent="space-between"
        >
            <Grid item>
                <GivelifyLabel variant="body2B" text={item.source.name} />
                <GivelifyLabel
                    variant="body2"
                    text={`${item.source.address} ${item.source.city}, ${item.source.state} ${item.source.zip}`}
                    className="address"
                />
            </Grid>
            <Grid item>
                <GivelifyButton
                    className="select"
                    variant="secondary"
                    text="Select"
                    onClick={handleSelect}
                    name="select"
                />
            </Grid>
        </SuggestionWrapper>
    );
};
